import React from "react";
import { upsconverter } from "../helperFunctions/helperFunctions";

export default function Comments({ num_comments, permalink }) {
  async function getComments() {
    // TODO: get and display comments
    const url = `https://www.reddit.com${permalink}.json`;
    const res = await fetch(url);
    const data = await res.json();
    console.log(data);
    return <p>Does this work?</p>;
  }
  return (
    <div
      className="comments-container"
      onClick={() => {
        getComments();
      }}
    >
      <i className="far fa-md fa-comment-alt"></i>
      <span className="comments-number">
        {" "}
        {upsconverter(num_comments)} comments
      </span>
    </div>
  );
}
